import { differenceWith, isEmpty } from 'lodash'
import { all, call, fork, put, race, select, take } from 'redux-saga/effects'
import {
  databaseForRoomsIsEmpty,
  dataForRoomsIsAccepted,
} from '../../actions/bookingCalendar/room/requestDataForRooms'
import {
  roomsSortRejected,
  roomsWasSorted,
} from '../../actions/bookingCalendar/room/sortRooms'
import { callFetch } from '../../actions/fetch'
import { requestSynchronization } from '../../actions/synchronize/synchronize'
import { IRoom } from '../../models/Room'
import { default as requestSort } from '../../models/Room/sortRooms'
import { RoomActions } from '../../reducers/bookingCalendar/actionNames'
import { getSortedRoomsByPosition } from '../../reducers/bookingCalendar/selectors/rooms'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import roomSort from '../../utils/RoomSort/roomSort'

function* updateSortRooms(rooms: IRoom[]) {
  try {
    const actionNames = fetchActionsName(ActionNames.SortRooms)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, requestSort)),
    ])

    yield call(service, rooms)

    yield put(roomsWasSorted({}))
  } catch (e) {
    if (e.message === '418') {
      yield put(databaseForRoomsIsEmpty())
      yield put(requestSynchronization())
    } else {
      yield put(roomsSortRejected())
    }
  }
}

function* sortRooms() {
  while (true) {
    const previousRooms = yield select(getSortedRoomsByPosition)
    yield race([
      take(RoomActions.DataForRoomsAccepted),
      take(RoomActions.RoomWasCreated),
      take(RoomActions.RoomWasUpdated),
      take(RoomActions.RoomWasDeleted),
    ])
    const rooms: IRoom[] = yield select(getSortedRoomsByPosition)
    const sorted = roomSort(previousRooms, rooms)
    const modified = differenceWith(
      rooms,
      sorted,
      (a, b) => a.id === b.id && a.position === b.position,
    )

    if (!isEmpty(modified)) {
      yield put(dataForRoomsIsAccepted(sorted, true))
      yield* updateSortRooms(sorted)
    }
  }
}

export default function*() {
  yield fork(sortRooms)
}
